module.exports = __webpack_public_path__ + "025c23f0ac3a34c4449dac78f1cccb09.gif";